export default "__VITE_ASSET__ChUpowHc__"